export const FAN_CONTENT_POLICY_URL = "https://company.wizards.com/en/legal/fancontentpolicy";

export function FanContentNotice({ compact = false }) {
  return (
    <p className={compact ? "px-3 py-1 text-center text-[10px] text-slate-500" : "text-xs leading-relaxed text-slate-500"} data-testid={compact ? "fan-content-disclaimer-compact" : "fan-content-disclaimer"}>
      The Planar Foundry is unofficial Fan Content permitted under the{" "}
      <a href={FAN_CONTENT_POLICY_URL} target="_blank" rel="noreferrer" className="text-slate-400 underline hover:text-amber-200" data-testid="fan-content-policy-link">Fan Content Policy</a>.
      {" "}Not approved/endorsed by Wizards. Portions of the materials used are property of Wizards of the Coast. ©Wizards of the Coast LLC.
      {!compact && " Magic: The Gathering, its mana symbols, card names and card images are trademarks of Wizards of the Coast LLC. The Planar Foundry is not affiliated with Wizards of the Coast or Hasbro."}
    </p>
  );
}
